<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getPutAways" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range id="fieldset-put-away-date" label-cols-sm="4" label-cols-lg="3"
							label="Date" size="sm" :modelFrom.sync="filter.putAwayDateFrom"
							:modelTo.sync="filter.putAwayDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber"
							optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="ControlCard" id="filter-" size="sm"
							:model.sync="filter.controlCardId" @input="getControlCards" @focus="getControlCards" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="putAwayCategorys" optionsLabel="name"
							optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Putaway Category" id="filter-" size="sm"
							:model.sync="filter.putAwayTypeId" @input="getPutAwayCategorys" @focus="getPutAwayCategorys" />
						<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Rack" id="filter-" size="sm"
							:model.sync="filter.rackId" @input="getRacks" @focus="getRacks" />
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark"
							label-for="filter-remark" size="sm" :model.sync="filter.remark" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getPutAways"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Put Away</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/putaway/PutAway.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download
								Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square
									class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download
							class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
							countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-putaway"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true"
					:no-local-sorting="true" :items="putAways" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="putAways.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Putaway Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-putaway-date-from-table" reset-button
								@input="getPutAwaysWithoutLoading" v-model="filter.putAwayDateFrom"
								size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-putaway-date-to-table" reset-button
								@input="getPutAwaysWithoutLoading" v-model="filter.putAwayDateTo"
								size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="PutAway Type" class="table-filter">
							<v-select append-to-body label="name" :options="putAwayCategorys" :value="filter.putAwayTypeId"
								:reduce="item => item.id" v-model="filter.putAwayTypeId" :filterable="true"
								@input="getPutAwaysWithoutLoading" @search="getPutAwayCategorys"></v-select>
						</b-th>
						<b-th stacked-heading="Control Card" class="table-filter">
							<v-select append-to-body label="controlCardNumber" :options="controlCards" :value="filter.controlCardId" :reduce="item => item.id" v-model="filter.controlCardId" :filterable="true" @input="getPutAwaysWithoutLoading" @search="getControlCards" @focus="getControlCards"></v-select>
						</b-th>
						<!-- <b-th stacked-heading="Control Card Number" class="table-filter">
							<v-select append-to-body label="controlCardNumber" :options="controlCards" :reduce="item => item.id" v-model="filter.controlCardId" :filterable="true" @input="getPutAwaysWithoutLoading" @search="getControlCards"></v-select>
						</b-th> -->
						<b-th stacked-heading="Rack" class="table-filter">
							<v-select append-to-body label="code" :options="racks" :value="filter.rackId"
								:reduce="item => item.id" v-model="filter.rackId" :filterable="true"
								@input="getPutAwaysWithoutLoading" @search="getRacks"></v-select>
						</b-th>
						<b-th stacked-heading="Remark" class="table-filter">
							<b-form-input id="input-remark-table" @input="getPutAwaysWithoutLoading" v-model="filter.remark"
								size="sm"></b-form-input>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(putawaydate)="row">
						{{ row.item.putAwayDate | moment("YYYY-MM-DD") }}
					</template>

					<template v-slot:cell(putAwayType)="row">
						{{ row.item.putAwayType != null ? row.item.putAwayType.name : "" }}
					</template>
					<template v-slot:cell(controlCard)="row">
						<a @click="() => ($router.push({ name: 'putawaydetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.controlCard != null && row.item.controlCard.controlCardNumber != null ?
								(typeof row.item.controlCard.controlCardNumber == 'string') ?
									row.item.controlCard.controlCardNumber.slice(0, 30) +
									(row.item.controlCard.controlCardNumber.length > 30 ? "..." : "") :
									row.item.controlCard.controlCardNumber : "" }}
						</a>
						<!-- {{ row.item.controlCard != null ? row.item.controlCard.controlCardNumber : "" }} -->
					</template>
					<template v-slot:cell(controlCardNumber)="row">
						{{ row.item.controlCard != null ? row.item.controlCard.controlCardNumber : "" }}
					</template>
					<template v-slot:cell(rack)="row">
						{{ row.item.rack != null ? row.item.rack.code : "" }}
					</template>
					<template v-slot:cell(remark)="row">
						<app-long-text :id="'remark-' + row.index"
							:text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
					</template>
					<template v-slot:cell(approval)="row">
						{{ row.item.approval != null ? row.item.approval.firstName : "" }}
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-combobox optionsLabel="controlCardNumber" label-cols-sm="12"
								:model="row.item.controlCardId" label="ControlCard"
								:selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-label label-cols-lg="12" size="sm" label="Control Card Number"
								:model="(model.controlCard != null) ? model.controlCard.controlCardNumber : null" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.rackId" label="Rack"
								:selected="row.item.rack != null ? row.item.rack.code : ''" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
								label-for="input-remark" size="sm" :model.sync="row.item.remark" :isEditable="false"
								:isUpdatable="true" />
							<app-input-combobox optionsLabel="firstName" label-cols-sm="12"
								:model="row.item.approvalUserName" label="Approval"
								:selected="row.item.approval != null ? row.item.approval.firstName : ''" :isEditable="false"
								:isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(putAwaysPaging != null ? putAwaysPaging.dataCount : 0)"
									:per-page="(putAwaysPaging != null ? putAwaysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId" @resetModalMethod="resetModal"
			label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-putaway.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-putaway.b-table>thead>tr>th {
	background: #e28b29;
}

::v-deep #table-list-putaway.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import PutAway from '@/models/PutAway/PutAway';
import PutAwayHeader from '@/models/PutawayHeader/PutawayHeader';
import PutAwayList from '@/models/PutAway/PutAwayList';
import PutAwayFilter from '@/filters/PutAway/PutAwayFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputRadio from '@/components/AppInputRadio';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import RackFilter from '@/filters/Rack/RackFilter';
import Rack from '@/models/Rack/Rack';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		PutAway,
		PutAwayList,
		PutAwayFilter,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputRadio,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "putAwayDate": {}, "class": "th-put-away-date first-child", "label": "Date", key: 'putAwayDate', sortable: true },
				{ "putAwayType": {}, "class": "th-put-away-type", "label": "PutAway Type", key: 'putAwayType', sortable: true },
				{ "controlCard": {}, "class": "th-control-card last-child", "label": "Control Card Number", key: 'controlCard', sortable: true },
				//{ "controlCardNumber": {}, "class": "th-control-card-number d-stack-none", "label": "Control Card Number", key: 'controlCardNumber', sortable: true },
				{ "rack": {}, "class": "th-rack d-stack-none", "label": "Rack", key: 'rack', sortable: true },
				{ "remark": {}, "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: true },
				// { "approval": {}, "class": "th-approval d-stack-none", "label": "Approval", key: 'approval', sortable: true },
				// { "isLocked": {}, "class": "th-is-locked d-stack-none", "label": "IsLocked", key: 'isLocked', sortable: true },

				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			putAways: [],
			putAwaysPaging: {},
			controlCards: [],
			racks: [],
			userInfos: [],
			putAwayCategorys: [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
		}
	},
	methods: {
		createData() {
			this.isCreateBusy = true;
			PutAwayHeader.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'putawayscan';
						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		getPutAways: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PutAway.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.putAways = result.data
						this.putAwaysPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getPutAwaysWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PutAway.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.putAways = result.data
						this.putAwaysPaging = result
					}
				})
				.catch(error => { });
		},
		getPutAwayCategorys: async function (input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PutAwayCategory.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.putAwayCategorys = result.data
					}
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			
			if (this.filter.controlCardId != undefined && input == '') {
				filter.id = this.filter.controlCardId;
			}
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
				})
				.catch(error => { });
		},
		getRacks: async function (input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.racks = result.data
					}
				})
				.catch(error => { });
		},
		getUserInfos: async function (input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.userInfos = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new PutAwayFilter();
			this.getPutAways();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPutAways();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PutAway.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PutAway.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			console.log('this.filter', this.filter);
			PutAway.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					console.log('result ', result);
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},

		deleteData(id) {
			PutAway.deleteData(this, id).then(result => {
				if (result) {
					this.getPutAways();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PutAway.deleteMultipleData(this).then(result => {
					this.getPutAways();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePutAwayParent = document.getElementById('table-list-putaway').parentNode;
			tablePutAwayParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePutAwayParent.scrollWidth - tablePutAwayParent.offsetWidth) == Math.ceil(tablePutAwayParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePutAwayParent = document.getElementById('table-list-putaway').parentNode;
			tablePutAwayParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePutAwayParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PutAwayFilter();
		this.getPutAwayCategorys()
		this.getControlCards()
		this.getRacks()
		// this.getUserInfos()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Put Away"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPutAways();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getPutAways();
			}
		},
		sortDesc: {
			handler: function () {
				this.getPutAways();
			}
		},
		currentPage: {
			handler: function () {
				this.getPutAways();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getPutAways();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PutAway.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "putawayindex") {
					this.getPutAwaysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "put_away").first();
		},
		isShowDeleteButton: function () {
			// let userRoleAllowDelete = true;
			// if (this.userRole != null) {
			// 	userRoleAllowDelete = this.userRole.allowDelete;
			// }

			// if (window.innerWidth <= 576) {
			// 	if (userRoleAllowDelete) {
			// 		if (this.checkAllData.length > 0) return true;
			// 	}
			// 	return false;
			// }

			return false;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
